var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.831 4.78406L10.2157 0.168794C10.108 0.0610251 9.96092 -0.000244141 9.80769 -0.000244141H1.73077C0.776423 -0.000244141 0 0.776179 0 1.73053V17.9613C0 18.9156 0.776423 19.6921 1.73077 19.6921H13.2692C14.2236 19.6921 15 18.9156 15 17.9613V5.19206C15 5.03476 14.934 4.88703 14.831 4.78406ZM10.3846 1.96949L13.0303 4.61514H10.9615C10.6434 4.61514 10.3846 4.35633 10.3846 4.03822V1.96949ZM13.2692 18.5382H1.73077C1.41265 18.5382 1.15385 18.2794 1.15385 17.9613V1.73053C1.15385 1.41241 1.41265 1.1536 1.73077 1.1536H9.23077V4.03822C9.23077 4.99256 10.0072 5.76899 10.9615 5.76899H13.8462V17.9613C13.8462 18.2794 13.5873 18.5382 13.2692 18.5382Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 8.64624H4.03688C3.71827 8.64624 3.45996 8.90455 3.45996 9.22316C3.45996 9.54178 3.71827 9.80009 4.03688 9.80009H10.96C11.2786 9.80009 11.5369 9.54178 11.5369 9.22316C11.5369 8.90455 11.2786 8.64624 10.96 8.64624Z",
    fill: "#3CB4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 6.40015H4.03688C3.71827 6.40015 3.45996 6.65845 3.45996 6.97707C3.45996 7.29568 3.71827 7.55399 4.03688 7.55399H10.96C11.2786 7.55399 11.5369 7.29568 11.5369 6.97707C11.5369 6.65845 11.2786 6.40015 10.96 6.40015Z",
    fill: "#3CB4E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 10.9539H4.03688C3.71827 10.9539 3.45996 11.2122 3.45996 11.5308C3.45996 11.8494 3.71827 12.1077 4.03688 12.1077H10.96C11.2786 12.1077 11.5369 11.8494 11.5369 11.5308C11.5369 11.2122 11.2786 10.9539 10.96 10.9539Z",
    fill: "#3CB4E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 13.261H4.03688C3.71827 13.261 3.45996 13.5193 3.45996 13.8379C3.45996 14.1565 3.71827 14.4148 4.03688 14.4148H10.96C11.2786 14.4148 11.5369 14.1565 11.5369 13.8379C11.5369 13.5193 11.2786 13.261 10.96 13.261Z",
    fill: "#3CB4E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65227 15.5691H4.03688C3.71827 15.5691 3.45996 15.8274 3.45996 16.146C3.45996 16.4646 3.71827 16.7229 4.03688 16.7229H8.65227C8.97088 16.7229 9.22919 16.4646 9.22919 16.146C9.22919 15.8274 8.97088 15.5691 8.65227 15.5691Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.2dddbe81cdb0d3ca66881bfd8fe0bc06.svg";
export { ForwardRef as ReactComponent };